<script lang="ts" setup>
import type { PropType } from 'vue';
interface Department {
    title: string;
    contacts: {
        title: string;
        email: string;
    }[];
}

const props = defineProps({
    departments: Array as PropType<Department[]>,
});

function getMailTo(email: string): string {
    return `mailto:${email}`;
}
</script>
<template>
    <div class="department_contacts">
        <h3 class="department_contacts-title title-l">Department Contacts</h3>
        <hr>
        <div class="department_contacts-columns">
            <div v-for="(department, index) of departments" class="department_contacts-column" :key="`department-${index}`">
                <h4 class="department_contacts-column--title title-m">{{ department.title }}</h4>
                <p v-for="(contact, contactIndex) of department.contacts" class="department_contacts-column--contact" :key="`contact-${contactIndex}`">
                    {{ contact.title }}
                    <br />
                    <a :href="getMailTo(contact.email)">{{ contact.email }}</a>
                </p>
            </div>
        </div>
    </div>
</template>